import { render, staticRenderFns } from "./testingCounterInput.vue?vue&type=template&id=083a48c4&"
import script from "./testingCounterInput.vue?vue&type=script&lang=js&"
export * from "./testingCounterInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports